import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
export var CorrectAnswer = /*#__PURE__*/function (_Entity) {
  _inherits(CorrectAnswer, _Entity);

  var _super = _createSuper(CorrectAnswer);

  function CorrectAnswer() {
    _classCallCheck(this, CorrectAnswer);

    return _super.apply(this, arguments);
  }

  _createClass(CorrectAnswer, [{
    key: "answerId",
    get: function get() {
      return this.props.answerId;
    }
  }, {
    key: "clone",
    value: function clone() {
      return CorrectAnswer.create(_objectSpread(_objectSpread({}, this.props), {}, {
        id: this.id.toString()
      })).getValue();
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }, {
    key: "updateAnswerId",
    value: function updateAnswerId(answerId) {}
  }], [{
    key: "validate",
    value: function validate(props) {
      var guardResult = Guard.againstNullOrUndefined(props, 'Correct Answer Props');

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      var guardCollection = [{
        argument: props.answerId,
        argumentName: 'Answer Id Matched'
      }];
      var guardCollectionsResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardCollectionsResult.succeeded) {
        var _guardCollectionsResu;

        return Result.fail((_guardCollectionsResu = guardCollectionsResult.message) !== null && _guardCollectionsResu !== void 0 ? _guardCollectionsResu : 'Error');
      }

      return Result.ok();
    }
  }, {
    key: "create",
    value: function create(props) {
      var guardResult = Guard.againstNullOrUndefined(props, 'Correct Answer Props');

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      var guardCollections = [{
        argument: props.answerId,
        argumentName: 'Answer id'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      return Result.ok(new CorrectAnswer(props, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var id = data.id,
            answerId = data.answerId;
        return this.create({
          id: id,
          answerId: answerId
        });
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return CorrectAnswer;
}(Entity);